export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8318.eb0b23e5.jpg";